import { useMutation } from '@cedarjs/web'
import { toast } from "@cedarjs/web/toast"
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconButton, PaperProps } from '@mui/material'
import { t } from "i18next"
import { useAuth } from "src/auth"

const CheckTrueButton = ({ onClick, reviewComment, isCheckedByUser}) => {
  return (
    <IconButton onClick={() => onClick(reviewComment.id, true)} className="lowercase" title={t("actions.check")} color={isCheckedByUser === true ? "success" : "default"} size="small">
      <FontAwesomeIcon icon={faCheck} />
    </IconButton>
  )
}
const CheckFalseButton = ({ onClick, reviewComment, isCheckedByUser}) => {
  return (
    <IconButton onClick={() => onClick(reviewComment.id, false)} className="lowercase" title={t("actions.cancel")} color={isCheckedByUser === false ? "warning" : "default"} size="small">
      <FontAwesomeIcon icon={faXmark} />
    </IconButton>
  )
}

const CREATE_REVIEW_CHECK = gql`
  mutation CreateReviewCommentCheckNewMutation($input: CreateReviewCommentCheckInput!) {
    createReviewCommentCheck(input: $input) {
      id
      createdAt
      createdBy
    }
  }
`
const DELETE_REVIEW_CHECK = gql`
  mutation UpdateReviewCommentCheckNewMutation($id: Int!) {
    deleteReviewCommentCheck(id: $id) {
      id
      createdAt
      createdBy
    }
  }
`

const ReviewCommentCheck = (props) => {

  const [createReviewCommentCheck] = useMutation(CREATE_REVIEW_CHECK, { onError(error) { toast.error(error.message) } })
  const [deleteReviewCommentCheck] = useMutation(DELETE_REVIEW_CHECK, { onError(error) { toast.error(error.message) } })
  const {currentUser} = useAuth()
  const userCheck = props.reviewComment?.checks?.find(check => check.createdBy == currentUser.id)
  const isCheckedByUser = userCheck ? userCheck.checked : null

  const onSave = (
    id: number,
    checked: boolean
  ) => {
    if(userCheck)
      return deleteReviewCommentCheck({ variables: { id : userCheck.id }, refetchQueries: ["FindReviewsQuery", 'FindReviewsSiteQuery', 'TankInfosQuery', 'BatchInfosQuery'] })
    else
      return createReviewCommentCheck({ variables: { input: {idReviewComment: id, checked } }, refetchQueries: ["FindReviewsQuery", 'FindReviewsSiteQuery', 'TankInfosQuery', 'BatchInfosQuery'] })
  }
  if (props.checks === true)
    return <CheckFalseButton {...props} onClick={onSave} isCheckedByUser={isCheckedByUser}/>
  else
    return <CheckTrueButton {...props} onClick={onSave} isCheckedByUser={isCheckedByUser}/>
}
export default ReviewCommentCheck